import { render } from "./area-list.vue?vue&type=template&id=71cf06f6&scoped=true"
import script from "./area-list.vue?vue&type=script&lang=js"
export * from "./area-list.vue?vue&type=script&lang=js"

import "./area-list.vue?vue&type=style&index=0&id=71cf06f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cf06f6"]])

export default __exports__